export const QUERY_IDENTITY_VERIFICATION_REQUEST =
  "QUERY_IDENTITY_VERIFICATION_REQUEST";
